import { app } from './bootstrap/core';

// Create application wide cache with the following set of methods:
app.provider('appCache', function () {
  'ngInject';

  const cache = {
    set: (key, value) => {
      try {
        sessionStorage.setItem(key, angular.toJson(value));
      } catch (ex) {
        // also set value as cookie to access it if sessionStorage is not available
        // eslint-disable-next-line
        document.cookie =
          key + '=' + (angular.toJson(value) || '') + '; path=/';
        // eslint-disable-next-line
        if (window.Raven) {
          // eslint-disable-next-line
          Raven.captureException(ex);
        }
      }
    },
    get: (key) => {
      try {
        let value = angular.fromJson(sessionStorage.getItem(key));
        // sometime a exception is may not thrown try it as fallback when not present
        if (!value) {
          // eslint-disable-next-line
          let result = document.cookie.match(
            '(^|;)\\s*' + key + '\\s*=\\s*([^;]+)',
          );

          if (result) {
            value = angular.fromJson(result.pop());
          }
        }
        return value;
      } catch (ex) {
        // session storage not available fallback to cookie
        try {
          // eslint-disable-next-line
          let result = document.cookie.match(
            '(^|;)\\s*' + key + '\\s*=\\s*([^;]+)',
          );

          if (result) {
            return angular.fromJson(result.pop());
          }
        } catch (ex) {
          // eslint-disable-next-line
          if (window.Raven) {
            // eslint-disable-next-line
            Raven.captureException(ex);
          }
        }
      }
      return;
    },
    remove: (key) => {
      sessionStorage.removeItem(key);
    },
    clear: () => {
      sessionStorage.clear();
    },
    clearExcept: (keysToKeep) => {
      const savedValues = {};
      keysToKeep.forEach((key) => {
        const value = sessionStorage.getItem(key);
        if (value !== null) {
          savedValues[key] = value;
        }
      });

      sessionStorage.clear();

      Object.keys(savedValues).forEach((key) => {
        sessionStorage.setItem(key, savedValues[key]);
      });
    },
  };

  // Assign cache functions to this instance (so we can use appCache at runtime)
  Object.assign(this, cache);

  // Fill in the cache as $get method on the provider (so we can use appCacheProvider at configtime)
  this.$get = () => cache;
});



// WEBPACK FOOTER //
// ./src/app/app.cache.js